@if (this.item.parameters?.slot; as slot) {
    <vn-dynamic-layout-slot cssClass="am-slot" [slot]="slot" />
}
